import store from '../../../store/store';
import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { ACTION_SETTINGS_URL } from './action-api-urls';
import { ShopActionSettings } from './action-types';

export interface GetActionSettingsResponse {
  success: boolean;
  message: string | null;
  data: ShopActionSettings | null;
}

export default async function get_action_settings_api_call(): Promise<ShopActionSettings | null> {
  try {
    const shopSlug = store.getState().user?.company?.shop_slug;
    const accessToken = store.getState().auth.authorization.accessToken;
    const sellerToken = accessToken?.sellerToken;

    const requestInfo: RequestInfo = {
      url: ACTION_SETTINGS_URL(shopSlug),
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: accessToken.type + ' ' + sellerToken,
      },
    };

    const actionType = 'GET_ACTION_SETTINGS';
    const customMsg = 'Action settings retrieved successfully.';

    const res: any = await asyncHandler(
      requestInfo,
      actionType,
      customMsg,
      false
    );

    const response: GetActionSettingsResponse = res?.data;

    if (res?.actionType === actionType && response?.success === true) {
      return response.data;
    } else {
      return null;
    }
  } catch (exception) {
    console.log('Error during get action settings request');
    return null;
  }
}
